import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GTM_ID = process.env.REACT_APP_GTM_ID || "";
const GA4_ID = process.env.REACT_APP_GA4_ID || "";

let loaded = false;

const loadGTM = () => {
  if (loaded || !GTM_ID) return;
  loaded = true;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(s);
};

const loadGA4 = () => {
  if (!GA4_ID || GTM_ID) return; // if GTM is used, GA4 is configured inside GTM
  if (window.__ga4Loaded) return;
  window.__ga4Loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA4_ID, { anonymize_ip: true, send_page_view: false });
};

const trackPageview = (path) => {
  if (!GTM_ID && !GA4_ID) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "page_view",
    page_path: path,
    page_title: document.title,
    page_location: window.location.href,
  });
  if (GA4_ID && window.gtag && !GTM_ID) {
    window.gtag("event", "page_view", {
      page_path: path,
      page_title: document.title,
      page_location: window.location.href,
    });
  }
};

export const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    loadGTM();
    loadGA4();
  }, []);

  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};

export default Analytics;
